import { render, staticRenderFns } from "./PrivacyConsent.vue?vue&type=template&id=3d130c43&scoped=true"
import script from "./PrivacyConsent.vue?vue&type=script&lang=js"
export * from "./PrivacyConsent.vue?vue&type=script&lang=js"
import style0 from "./PrivacyConsent.vue?vue&type=style&index=0&id=3d130c43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d130c43",
  null
  
)

export default component.exports